import React from "react";

import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const { RangePicker } = DatePicker;

function DateRange({ value, onChange }) {
  const { t } = useTranslation();

  // Convert the value (Array [start, end]) to array of dayjs for RangePicker
  const getRangeValue = () => {
    if (Array.isArray(value) && value.length === 2) {
      return [dayjs(value[0]), dayjs(value[1])];
    }
    // Backward compatibility for object {start, end}
    if (value && value.start && value.end) {
      return [dayjs(value.start), dayjs(value.end)];
    }
    return [];
  };

  const handleChange = (dates) => {
    if (dates && dates.length === 2) {
      onChange([
        dates[0].startOf('day'),
        dates[1].endOf('day')
      ]);
    } else {
      onChange(undefined);
    }
  };

  return (
    <RangePicker
      value={getRangeValue()}
      onChange={handleChange}
      placeholder={[
        t('common.table.filters.date_range_start_placeholder'),
        t('common.table.filters.date_range_end_placeholder')
      ]}
      style={{ width: '100%' }}
      allowClear
    />
  );
}

export default DateRange;
